import { render, staticRenderFns } from "./carer-suggestion-2-pdf.vue?vue&type=template&id=95b0b356&"
import script from "./carer-suggestion-2-pdf.component.ts?vue&type=script&lang=ts&"
export * from "./carer-suggestion-2-pdf.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports